var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotHoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22612_14135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.8316,
    cy: 32.3882,
    r: 28.7222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8316,
    cy: 32.3882,
    r: 25.2222,
    stroke: "#00546E",
    strokeWidth: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22612_14135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.0582,
    cy: 28.7222,
    r: 28.7222,
    fill: "#00171E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.0582,
    cy: 28.7222,
    r: 25.2222,
    stroke: "#002E3C",
    strokeWidth: 7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.1671C14.8647 47.1671 21.4561 33.518 21.4561 26.8327C21.4561 40.2032 33.3889 47.1671 42.1964 47.1671C27.6498 47.1671 21.4561 59.4234 21.4561 67.2229C21.4561 53.8523 8.67105 47.1671 1 47.1671Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7758 26.9172C49.1903 26.9172 53.1906 18.6336 53.1906 14.5764C53.1906 22.6909 60.4325 26.9172 65.7778 26.9172C56.9495 26.9172 53.1906 34.3555 53.1906 39.089C53.1906 30.9745 45.4314 26.9172 40.7758 26.9172Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4561 14.9068C26.6196 14.9068 29.0743 9.82367 29.0743 7.33398C29.0743 12.3134 33.5182 14.9068 36.7982 14.9068C31.3809 14.9068 29.0743 19.4712 29.0743 22.3758C29.0743 17.3965 24.3129 14.9068 21.4561 14.9068Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.1671C14.8647 47.1671 21.4561 33.518 21.4561 26.8327C21.4561 40.2032 33.3889 47.1671 42.1964 47.1671C27.6498 47.1671 21.4561 59.4234 21.4561 67.2229C21.4561 53.8523 8.67105 47.1671 1 47.1671Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7758 26.9172C49.1903 26.9172 53.1906 18.6336 53.1906 14.5764C53.1906 22.6909 60.4325 26.9172 65.7778 26.9172C56.9495 26.9172 53.1906 34.3555 53.1906 39.089C53.1906 30.9745 45.4314 26.9172 40.7758 26.9172Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4561 14.9068C26.6196 14.9068 29.0743 9.82367 29.0743 7.33398C29.0743 12.3134 33.5182 14.9068 36.7982 14.9068C31.3809 14.9068 29.0743 19.4712 29.0743 22.3758C29.0743 17.3965 24.3129 14.9068 21.4561 14.9068Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 45.9444C16.0874 45.9444 22.6788 32.2953 22.6788 25.61C22.6788 38.9806 34.6115 45.9444 43.4191 45.9444C28.8725 45.9444 22.6788 58.2007 22.6788 66.0002C22.6788 52.6297 9.89371 45.9444 2.22266 45.9444Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9985 25.6946C50.4129 25.6946 54.4132 17.411 54.4132 13.3537C54.4132 21.4682 61.6552 25.6946 67.0004 25.6946C58.1722 25.6946 54.4132 33.1329 54.4132 37.8664C54.4132 29.7518 46.654 25.6946 41.9985 25.6946Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6788 13.6841C27.8422 13.6841 30.2969 8.60102 30.2969 6.11133C30.2969 11.0907 34.7409 13.6841 38.0209 13.6841C32.6035 13.6841 30.2969 18.2486 30.2969 21.1532C30.2969 16.1738 25.5356 13.6841 22.6788 13.6841Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 45.9444C16.0874 45.9444 22.6788 32.2953 22.6788 25.61C22.6788 38.9806 34.6115 45.9444 43.4191 45.9444C28.8725 45.9444 22.6788 58.2007 22.6788 66.0002C22.6788 52.6297 9.89371 45.9444 2.22266 45.9444Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9985 25.6946C50.4129 25.6946 54.4132 17.411 54.4132 13.3537C54.4132 21.4682 61.6552 25.6946 67.0004 25.6946C58.1722 25.6946 54.4132 33.1329 54.4132 37.8664C54.4132 29.7518 46.654 25.6946 41.9985 25.6946Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6788 13.6841C27.8422 13.6841 30.2969 8.60102 30.2969 6.11133C30.2969 11.0907 34.7409 13.6841 38.0209 13.6841C32.6035 13.6841 30.2969 18.2486 30.2969 21.1532C30.2969 16.1738 25.5356 13.6841 22.6788 13.6841Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22612_14135",
    x: 3.10938,
    y: 3.66602,
    width: 65.4453,
    height: 65.4453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22612_14135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22612_14135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_22612_14135",
    x: 4.33594,
    y: 0,
    width: 65.4453,
    height: 65.4453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22612_14135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22612_14135",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotHoverIcon);
export default __webpack_public_path__ + "static/media/chatbotHoverIcon.8bf9efa35d8545a20b8d570c9c572ee4.svg";
export { ForwardRef as ReactComponent };